import { createFileRoute } from "@tanstack/react-router"

import ConsumerNav from "@/components/homepage/consumer-nav"
import Markdown from "@/components/markdown"
import { SharedFooter } from "@/components/shared-footer"
import content from "@/methodology/content.md?raw"

export const Route = createFileRoute("/methodology")({
  component: MethodologyPage,
  head: () => ({
    meta: [{ title: "Our Methodology | WattBot" }],
  }),
})

function MethodologyPage() {
  return (
    <div className="bg-muted min-h-screen p-4 sm:p-6 lg:p-8">
      <main className="bg-background mx-auto max-w-[1400px] border-2 shadow-md">
        <ConsumerNav />
        <div className="mx-auto max-w-(--breakpoint-sm) px-6">
          <Markdown>{content}</Markdown>
        </div>
        <SharedFooter />
      </main>
    </div>
  )
}
